/**
 * Overlay semiópaco cuando el popup de cookies está visible.
 * - Si hay CookieConsent con datos (Shopify): overlay siempre oculto.
 * - Si no hay datos: mostramos overlay cuando el banner (id shopify-pc__banner) está visible;
 *   al detectar click (aceptar/rechazar) quitamos el overlay.
 */
(function () {
  const OVERLAY_ID = 'cookie-consent-overlay';
  const OVERLAY_VISIBLE_CLASS = 'is-visible';
  const BODY_ACTIVE_CLASS = 'cookie-consent-active';
  const BANNER_ID = 'shopify-pc__banner';
  const LOG = function (msg, data) {
    try {
      var out = '[cookie-overlay] ' + msg;
      if (typeof console !== 'undefined') {
        if (data !== undefined) { console.log(out, data); console.warn(out, data); }
        else { console.log(out); console.warn(out); }
      }
    } catch (e) {}
  };
  LOG('script cargado');

  var processStopped = false;
  var observerRef = null;
  var intervalRef = null;
  var mo2Ref = null;
  var visibleCheckInterval = null;
  var consentApiReady = false;

  function getOverlay() {
    return document.getElementById(OVERLAY_ID);
  }

  function getCustomSelector() {
    var el = document.querySelector('[data-cookie-banner-selector]');
    return el ? el.getAttribute('data-cookie-banner-selector') : null;
  }

  function hasConsentData() {
    if (!consentApiReady || !window.Shopify || !window.Shopify.customerPrivacy) return false;
    try {
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      if (!consent || typeof consent !== 'object') return false;
      var keys = ['marketing', 'analytics', 'preferences', 'sale_of_data'];
      for (var i = 0; i < keys.length; i++) {
        var val = consent[keys[i]];
        if (val != null && String(val).trim() !== '') {
          var v = String(val).toLowerCase().trim();
          if (v === 'yes' || v === 'no') return true;
        }
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  function isBannerVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.visibility !== 'hidden' &&
      style.display !== 'none' &&
      parseFloat(style.opacity) > 0
    );
  }

  function findVisibleBanner() {
    var custom = getCustomSelector();
    var el = custom ? document.querySelector(custom) : document.getElementById(BANNER_ID);
    if (el && el.id !== OVERLAY_ID && isBannerVisible(el)) {
      LOG('findVisibleBanner: encontrado', el.id || custom);
      return el;
    }
    LOG('findVisibleBanner: no encontrado', 'id=' + BANNER_ID);
    return null;
  }

  function setOverlayVisible(visible) {
    var overlay = getOverlay();
    if (!overlay) return;
    if (visible) {
      overlay.classList.add(OVERLAY_VISIBLE_CLASS);
      document.body.classList.add(BODY_ACTIVE_CLASS);
    } else {
      overlay.classList.remove(OVERLAY_VISIBLE_CLASS);
      document.body.classList.remove(BODY_ACTIVE_CLASS);
      if (visibleCheckInterval) {
        clearInterval(visibleCheckInterval);
        visibleCheckInterval = null;
      }
    }
  }

  function stopProcess() {
    if (processStopped) return;
    processStopped = true;
    LOG('stopProcess: quitamos overlay y paramos observadores');
    setOverlayVisible(false);
    document.removeEventListener('click', onBannerClick, true);
    if (observerRef) observerRef.disconnect();
    if (intervalRef) clearInterval(intervalRef);
    if (visibleCheckInterval) { clearInterval(visibleCheckInterval); visibleCheckInterval = null; }
    if (mo2Ref) mo2Ref.disconnect();
  }

  function checkAndSyncOverlay() {
    if (processStopped) return;
    if (hasConsentData()) {
      setOverlayVisible(false);
      return;
    }
    var banner = findVisibleBanner();
    setOverlayVisible(!!banner);
  }

  function ensureOverlayInDom() {
    if (getOverlay()) return;
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'cookie-consent-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);
  }

  function forceOverlayHidden() {
    ensureOverlayInDom();
    setOverlayVisible(false);
  }

  function runInit() {
    if (hasConsentData()) {
      LOG('runInit: consent con datos → overlay siempre oculto');
      processStopped = true;
      forceOverlayHidden();
      setTimeout(forceOverlayHidden, 100);
      setTimeout(forceOverlayHidden, 400);
      return;
    }

    LOG('runInit: sin consent → observamos banner (id ' + BANNER_ID + ')');
    ensureOverlayInDom();

    document.addEventListener('click', onBannerClick, true);

    var debounceTimer;
    function debouncedCheck() {
      if (processStopped) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(checkAndSyncOverlay, 80);
    }

    checkAndSyncOverlay();

    observerRef = new MutationObserver(function (mutations) {
      if (processStopped) return;
      var skip = mutations.every(function (m) {
        return m.target.id === OVERLAY_ID || (m.target === document.body && m.attributeName === 'class');
      });
      if (!skip) debouncedCheck();
    });
    observerRef.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });

    intervalRef = setInterval(debouncedCheck, 600);
    setTimeout(function () { if (intervalRef) clearInterval(intervalRef); intervalRef = null; }, 20000);

    function startVisibleCheck() {
      if (visibleCheckInterval) return;
      visibleCheckInterval = setInterval(function () {
        if (processStopped) return;
        var ov = getOverlay();
        if (!ov || !ov.classList.contains(OVERLAY_VISIBLE_CLASS)) return;
        if (hasConsentData() || !findVisibleBanner()) setOverlayVisible(false);
      }, 350);
    }
    mo2Ref = new MutationObserver(function () {
      if (processStopped) return;
      var overlay = getOverlay();
      if (overlay && overlay.classList.contains(OVERLAY_VISIBLE_CLASS)) startVisibleCheck();
    });
    mo2Ref.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (getOverlay() && getOverlay().classList.contains(OVERLAY_VISIBLE_CLASS)) startVisibleCheck();
  }

  function onConsentCollected() {
    LOG('visitorConsentCollected → quitamos overlay');
    if (!processStopped) stopProcess();
  }

  function onBannerClick(e) {
    if (processStopped) return;
    var banner = document.getElementById(BANNER_ID);
    if (banner && banner.contains(e.target)) {
      LOG('click en banner (confirmación) → quitamos overlay');
      stopProcess();
    }
  }

  var runInitCalled = false;

  function runInitWhenReady() {
    if (runInitCalled) return;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        if (runInitCalled) return;
        runInitCalled = true;
        runInit();
      });
      return;
    }
    runInitCalled = true;
    runInit();
  }

  function init() {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      consentApiReady = true;
      runInitWhenReady();
      return;
    }
    var timeout = setTimeout(function () {
      if (runInitCalled) return;
      consentApiReady = false;
      runInitWhenReady();
    }, 2500);
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        clearTimeout(timeout);
        consentApiReady = !error;
        if (!error) document.addEventListener('visitorConsentCollected', onConsentCollected);
        runInitWhenReady();
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
